export const INVITATION_REQUIRED_AUTH_MESSAGE =
  'No account found for this account. Please use an invitation link from your admin or Hobbes contact.';

/**
 * Maps backend/provider auth errors to stable user-facing copy.
 */
export const normalizeAuthErrorMessage = (
  rawMessage: string | null | undefined,
  fallbackMessage: string
): string => {
  if (!rawMessage) {
    return fallbackMessage;
  }

  const trimmed = rawMessage.trim();
  const lower = trimmed.toLowerCase();

  const invitationRequired =
    lower.includes('no account found with this google account') ||
    lower.includes('please sign up with an invitation link') ||
    lower.includes('an invitation link is required to create an account') ||
    lower.includes('invitation link is required');

  if (invitationRequired) {
    return INVITATION_REQUIRED_AUTH_MESSAGE;
  }

  return trimmed;
};

/**
 * Returns true when the (already-normalised) message is the invite-required variant.
 */
export const isInvitationRequiredError = (message: string): boolean =>
  message === INVITATION_REQUIRED_AUTH_MESSAGE;
